import { Box, Stack, Text } from '@/ui';
import {
  settingsMetadataCellSx,
  settingsMetadataLabelTextSx,
  settingsMetadataRowSx,
  settingsMetadataValueTextSx,
} from '@/ui/composites/settingsPageTypographySx';
import type { ReactElement, ReactNode } from 'react';

type ProjectSettingsMetadataItem = {
  label: string;
  value: ReactNode;
};

type ProjectSettingsMetadataRowProps = {
  actionSlot?: ReactNode;
  items: ProjectSettingsMetadataItem[];
};

export const ProjectSettingsMetadataRow = ({
  actionSlot,
  items,
}: ProjectSettingsMetadataRowProps): ReactElement => (
  <Box sx={settingsMetadataRowSx}>
    {items.map((item) => (
      <Box key={item.label} sx={settingsMetadataCellSx}>
        <Stack gap="xxs">
          <Text role="bodyMuted" component="span" sx={settingsMetadataLabelTextSx}>
            {item.label}
          </Text>
          <Text role="body" sx={settingsMetadataValueTextSx}>
            {item.value}
          </Text>
        </Stack>
      </Box>
    ))}
    {actionSlot}
  </Box>
);
